import {
  MatCheckboxModule,
  MatButtonModule,
  MatFormFieldModule,
  MatInputModule,
  MatRippleModule,
  MatGridListModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatCardModule,
  MatRadioModule,
  MatSelectModule,
  MatDialogModule,
  MatPaginatorModule,
  MatTooltipModule,
  MatTableModule,
  MatSortModule,
} from "@angular/material";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
// Components imports below
import { EssentialService } from "./services/essential.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SearchResultComponent } from "./components/search-result/search-result.component";
import { SearchComponent } from "./components/search/search.component";
import { PhotoGalleryComponent } from "./components/photo-gallery/photo-gallery.component";
import { ParagraphComponent } from "./components/paragraph/paragraph.component";
import { StaticArticleComponent } from "./components/static-article/static-article.component";
import { ImageComponent } from "./components/image/image.component";
import { BannerComponent } from "./components/banner/banner.component";
import { BlogArchiveComponent } from "./components/blog-archive/blog-archive.component";
import { SocialShareLinksComponent } from "./components/social-share-links/social-share-links.component";
// import {
//   ChildsMenusComponent,
// } from "./components/header/header.component";

import { MenuComponent } from "./components/menu/menu.component";
import { ChildMenuComponent } from "./components/menu/child-menu/child-menu.component";
import { ButtonComponent } from "./components/button/button.component";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { GalleryComponent } from "./components/gallery/gallery.component";
import { NgxGalleryModule } from "ngx-gallery";
import { ModalModule } from "ngx-bootstrap/modal";
import { BlogDetailsComponent } from "./components/blog-details/blog-details.component";
import { OwlModule } from "ngx-owl-carousel";
import { LightboxModule } from "ngx-lightbox";
// import { ShareButtonsModule } from "@ngx-share/buttons";
 import { SharethisAngularModule } from 'sharethis-angular';
import { SharedModule } from "./shared-module/shared.module";
import { FaqComponent } from "./components/faq/faq.component";
import { AccordionModule } from "ngx-bootstrap/accordion";
import { ResetPasswordComponent } from "./components/reset-password/reset-password.component";
import { PopoverModule } from "ngx-bootstrap/popover";
import { FormBuilderService } from "./services/form-builder.service";
import { FormBuilderComponent } from "./components/form-builder/form-builder.component";
import { DataHtmlComponent } from "./components/html-data/html-data.component";
import { DataGridComponent } from "./components/data-grid/data-grid.component";
import {
  SitemapComponent,
  SiteMapChildsComponent,
} from "./components/sitemap/sitemap.component";
import { MenuDetailsComponent } from "./components/menu-details/menu-details.component";
import { BreadcrumbComponent } from "./components/breadcrumb/breadcrumb.component";
import { SubMenuComponent } from "./components/sub-menu/sub-menu.component";
import { LoginClientComponent } from "./components/login/login.component";
// import { UserProfileComponent } from './components/user-profile/user-profile.component';
// import { SubscribeComponent } from './components/subscribe/subscribe.component';
// import { MarqueeComponent } from './components/marquee/marquee.component';
// import { VideoComponent } from './components/video/video.component';
// import { SeparatorComponent } from './components/separator/separator.component';
// import { HtmlBlockComponent } from './components/html-block/html-block.component';
// import { CarouselModule } from 'ngx-bootstrap/carousel';
// import { FlexLayoutModule } from '@angular/flex-layout';
// import { MatVideoModule } from 'mat-video';
// import { PopoverComponent } from './components/popover/popover.component';
// import { CalendarComponent } from './components/calendar/calendar.component';
// import { FullCalendarModule } from '@fullcalendar/angular';
import { HeaderComponent,ChildsMenusComponent } from "./components/header/header.component";
import { RecursiveMenuComponent } from "./components/sub-menu/recursive-menu/recursive-menu.component";
// import { RecursiveMenuComponent } from "./components/sub-menu/recursive-menu/recursive-menu.component";
// import { RecaptchaModule, RecaptchaFormsModule } from "ng-recaptcha";
// import { TextHeaderComponent } from "./components/text-header/text-header.component";
// import { FooterComponent } from "./components/footer/footer.component";

var components = [
  ResetPasswordComponent,
  ChildsMenusComponent,
  BlogDetailsComponent,
  MenuDetailsComponent,
  ChildMenuComponent,
  GalleryComponent,
  ButtonComponent,
  MenuComponent,
  BlogArchiveComponent,
  BannerComponent,
  ImageComponent,
  StaticArticleComponent,
  ParagraphComponent,
  HeaderComponent,
  PhotoGalleryComponent,
  FaqComponent,
  FormBuilderComponent,
  DataGridComponent,
  DataHtmlComponent,
  SubMenuComponent,
  BreadcrumbComponent,
  SitemapComponent,
  SiteMapChildsComponent,
  SearchComponent,
  SearchResultComponent,
  SocialShareLinksComponent,
  RecursiveMenuComponent,
  LoginClientComponent,

  // TextHeaderComponent,
  // FooterComponent,
  // HtmlBlockComponent,
  // SeparatorComponent,
  // MarqueeComponent,
  // VideoComponent,
  // SubscribeComponent,
  // UserProfileComponent,
  // CalendarComponent,
];

@NgModule({
  declarations: components,
  exports: components,
  entryComponents: components,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    FormsModule,
    MatCheckboxModule,
    MatRadioModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatRippleModule,
    MatGridListModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCardModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatDialogModule,
    HttpClientModule,
    // BsDatepickerModule.forRoot(),
    // CarouselModule.forRoot(),
    BrowserAnimationsModule,
    // MatVideoModule,
    NgxGalleryModule,
    MatSortModule,
    MatPaginatorModule,
    MatTableModule,
    RouterModule.forChild([]),
    PaginationModule.forRoot(),
    // FullCalendarModule,
    ModalModule,
    OwlModule,
    LightboxModule,
    // FlexLayoutModule,
    PopoverModule.forRoot(),
    MatTooltipModule,
    // ShareButtonsModule.withConfig({ debug: true }),
    SharedModule,
    AccordionModule.forRoot(),
    // RecaptchaModule,
    // RecaptchaFormsModule,
    // FullCalendarModule,
    SharethisAngularModule
  ],
  providers: [EssentialService, FormBuilderService],
})
export class CommonLibModule {}
